module.exports = __webpack_public_path__ + "img/seccion-title.d8b634e0.png";